import { render, staticRenderFns } from "./Packing2.vue?vue&type=template&id=527cc807"
import script from "./Packing2.vue?vue&type=script&lang=js"
export * from "./Packing2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports